import _ from 'lodash';
import Signals from 'signals';
    

    function GridModel() {
        var self = this;
        self.sorting = null;
        self.pagination = null;
        self.headers = null;
        self.hiddenColumnIds = [];
        
        self.dataset = null;
        self.metadata = null;
        //  TODO: change 'signals' to "simple" observables as in 'observable-factory.ts'
        self.headersUpdated = new Signals.Signal();
        self.headersNeedsSave = new Signals.Signal();
        self.sortingUpdated = new Signals.Signal();
        self.sortingNeedsSave = new Signals.Signal();
        self.paginationUpdated = new Signals.Signal();
        self.paginationNeedsSave = new Signals.Signal();
        self.datasetUpdated = new Signals.Signal();
        self.activateFetchDataset = new Signals.Signal();
        self.activateInitialData = new Signals.Signal();
    }

    GridModel.prototype = {
        getSorting: function () {
            var self = this;
            return _.cloneDeep(self.sorting);
        },

        getSortingForApi: function () {
            var self = this;
            return _.map(_.cloneDeep(self.sorting), function (s) {
                return '' + s.colId + ',' + s.sort;
            });
        },

        getPagination: function () {
            var self = this;
            return _.cloneDeep(self.pagination);
        },

        getHeaders: function () {
            var self = this;
            return _.cloneDeep(self.headers);
        },

        getDataset: function () {
            var self = this;
            return _.cloneDeep(self.dataset);
        },

        getDatasetMetadata: function () {
            var self = this;
            return _.cloneDeep(self.metadata);
        },

        setSorting: function (options, needsSave) {
            var self = this;
            if (!_.isEqual(self.sorting, options)) {
                self.sorting = _.cloneDeep(options);
                self.sortingUpdated.dispatch();
                if (needsSave) {
                    self.sortingNeedsSave.dispatch();
                }
            }
        },

        setPagination: function (options, needsSave) {
            var self = this;
            self.pagination = _.cloneDeep(options);
            self.paginationUpdated.dispatch();
            if (needsSave) {
                self.paginationNeedsSave.dispatch();
            }
        },

        setHeaders: function (options, needsSave) {
            var self = this;
            self.headers = _.cloneDeep(options);

            _.forEach(self.headers, function (header) {
                header.hide = _.includes(self.hiddenColumnIds, header.field);
            });
            
            self.headersUpdated.dispatch();
            if (needsSave) {
                self.headersNeedsSave.dispatch();
            }
        },

        setDefaultSort: function() {
            var self = this;
            var sort = [];
            _.forEach(self.headers, function (header) {
                if(!_.isNil(header.sort)) {
                    sort = [{
                        colId: header.field,
                        sort: header.sort
                    }];
                    self.setSorting(sort, true);
                    return;
                }
            });
        },

        setHiddenHeaders: function (columnIds, needsSave) {
            var self = this;
            self.hiddenColumnIds = columnIds;
            var changed = false;
            _.forEach(self.headers, function (header) {
                var newHide = _.includes(columnIds, header.field);
                changed = changed || (header.hide !== newHide); 
                header.hide = newHide;
            });
            if (changed) {
                self.headersUpdated.dispatch();
            }
            if (needsSave && changed) {
                self.headersNeedsSave.dispatch();
            }
        },

        getHiddenHeaders: function () {
            var self = this;
            return _.map(_.filter(self.headers, ['hide', true]), 'field');
        },

        setDataset: function (dataset) {
            var self = this;
            self.dataset = _.cloneDeep(dataset);
            self.datasetUpdated.dispatch();
        },

        setDatasetMetadata: function (metadata) {
            var self = this;
            self.metadata = _.cloneDeep(metadata);
            if (self.sendActivateInitalDataWhenReady) {
                delete self.sendActivateInitalDataWhenReady;
                self.getInitialData();
            }
        }, 
        
        // todo this is a hack
        fetchDataset: function () {
            var self = this;
            self.activateFetchDataset.dispatch();
        },
        // todo this is a hack
        getInitialData: function () {
            var self = this;
            if (self.metadata) {
                self.activateInitialData.dispatch();
            } else {
                self.sendActivateInitalDataWhenReady = true;
            }
        },
    };

    export default GridModel;

